import type { AiChatContext } from './context'

/** Handles the two decisions available on a V2 gateway confirmation card. */
export function usePendingConfirmations(
  ctx: AiChatContext,
  resumeConfirmation: (
    pendingConfirmationId: string,
    userChoice?: 'CONFIRM' | 'CANCEL',
    riskAcknowledged?: boolean
  ) => Promise<void>
): {
  confirmPendingConfirmation: (riskAcknowledged?: boolean) => Promise<void>
  cancelPendingConfirmation: () => Promise<void>
} {
  const {
    sessionId,
    lastError,
    confirmationHttpPending,
    pendingConfirmation
  } = ctx

  function currentPendingId(): string | null {
    const pending = pendingConfirmation.value
    if (!pending || confirmationHttpPending.value) return null
    const currentSessionId = sessionId.value?.trim() ?? ''
    if (!currentSessionId || pending.conversationSessionId !== currentSessionId) return null
    return pending.id
  }

  async function resume(
    userChoice: 'CONFIRM' | 'CANCEL',
    riskAcknowledged = false
  ): Promise<void> {
    const pendingId = currentPendingId()
    if (!pendingId) return
    confirmationHttpPending.value = true
    lastError.value = null
    try {
      await resumeConfirmation(pendingId, userChoice, riskAcknowledged)
    } finally {
      confirmationHttpPending.value = false
    }
  }

  return {
    confirmPendingConfirmation: (riskAcknowledged = false) =>
      resume('CONFIRM', riskAcknowledged),
    cancelPendingConfirmation: () => resume('CANCEL')
  }
}
